<template>
  <div>
    <slot />

    <TwitchStream
      v-if="$page.props.settings.twitch && $page.props.settings.show_stream"
      :twitch-url="$page.props.settings.twitch_url"
    />
  </div>
</template>

<script>
import TwitchStream from '../Partials/TwitchStream.vue';

export default {
  components: {TwitchStream},
};
</script>
